import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateStreamingIndicator} from '../streaming-indicator/index.js';

import EVENT_TIMING_STATUS from './event-timing-status.palette-schema.yaml';

registerTileSchema(EVENT_TIMING_STATUS);

export function generateEventTimingStatus(TILE) {
    return {
        dateTimeContainer: {
            separator: {
                style: {
                    color: TILE.EVENT_TIMING_SEPARATOR_COLOR,
                },
            },
        },
        liveText: {
            style: {
                fontSize: 12,
                whiteSpace: 'nowrap',
                ...TILE.EVENT_TIMING_LIVE_TEXT,
            },
        },
        upcomingText: {
            style: {
                fontSize: 12,
                whiteSpace: 'nowrap',
                ...TILE.EVENT_TIMING_UPCOMING_TEXT,
            },
        },
        streamingIcon: generateStreamingIndicator(TILE.STREAMING_INDICATOR),
    };
}
